export const memberCheckout = (axiosInstance, data) => {
    const url = `v1/subscriptions/subscribe`;
    return axiosInstance.post(url, data);
};

export const powerMemberCheckout = (axiosInstance, data) => {
    const url = `v1/subscriptions/power/subscribe`;
    return axiosInstance.post(url, data);
};

export const confirmPowerMemberCheckout = (axiosInstance, subscriptionId) => {
    const url = `v1/subscriptions/power/confirmPayment?sourceSubscriptionId=${subscriptionId}`;
    return axiosInstance.put(url);
};

export const deletePendingPowerSubscription = (axiosInstance, subscriptionId) => {
    const url = `v1/subscriptions/power/failpayment?sourceSubscriptionId=${subscriptionId}`;
    return axiosInstance.delete(url);
};

export const clubCheckout = (axiosInstance, data) => {
    const url = `v1/subscriptions/clubs/${data.clubId}/subscribe`;
    return axiosInstance.post(url, data);
};

export const confirmClubCheckout = (axiosInstance, clubId, sourceSubscriptionId) => {
    const url = `v1/subscriptions/clubs/${clubId}/confirmpayment`;
    return axiosInstance.put(url, { sourceSubscriptionId });
};

export const failClubCheckout = (axiosInstance, clubId, sourceSubscriptionId) => {
    const url = `v1/subscriptions/clubs/${clubId}/failpayment`;
    return axiosInstance.put(url, { sourceSubscriptionId });
};
export const enterpriseClubCheckout = (axiosInstance, data) => {
    const url = `v1/subscriptions/enterpriseclub/${data.clubId}/subscribe`;
    return axiosInstance.post(url, data);
};

export const confirmEnterpriseClubCheckout = (axiosInstance, clubId, sourceSubscriptionId, inviteToken) => {
    const url = `v1/subscriptions/enterpriseclub/${clubId}/confirmpayment`;
    return axiosInstance.put(url, { sourceSubscriptionId, inviteToken });
};

export const failEnterpriseClubCheckout = (axiosInstance, clubId, sourceSubscriptionId) => {
    const url = `v1/subscriptions/enterpriseclub/${clubId}/failpayment`;
    return axiosInstance.put(url, { sourceSubscriptionId });
};

export const memberCancel = (axiosInstance, subscriptionId, cancellationReason) => {
    const url = `v1/subscriptions/cancel?subscriptionId=${subscriptionId}`;
    return axiosInstance.post(url, { cancellationReason });
};

export const memberRenew = (axiosInstance) => {
    const url = `v1/subscriptions/renew`;
    return axiosInstance.post(url, {});
};

export const clubRenew = (axiosInstance, clubId) => {
    const url = `v1/subscriptions/clubs/${clubId}/renew`;
    return axiosInstance.post(url, {});
};

export const subscriptionInfo = (axiosInstance) => {
    const url = `v1/subscriptions/list`;
    return axiosInstance.get(url);
};

export const updatePayment = (axiosInstance, data) => {
    let url;
    if (data.paymentMethodId) {
        url = `v1/subscriptions/payment/update?paymentMethodId=${data.paymentMethodId}&subscriptionId=${data.subscriptionId}`;
    } else {
        url = `v1/subscriptions/payment/update?stripeToken=${data.token}&subscriptionId=${data.subscriptionId}`;
        if (data.shouldSaveCard) {
            url = `${url}&isSavingCard=${data.shouldSaveCard}`;
        }
    }
    return axiosInstance.put(url, {});
};

export const getPowerSubscriptionDetails = (axiosInstance, params) => {
    const url = `v1/subscriptions/subscribe`;
    return axiosInstance.get(url, {
        params: {
            plan: params.plan,
            couponCode: params.couponCode,
        },
    });
};

export const getPowerSubscriptionPlans = (axiosInstance) => {
    const url = `v1/subscriptions/power/plans`;
    return axiosInstance.get(url);
};

export const getMonthlyToAnnualUpgradeDetails = (axiosInstance) => {
    const url = `v1/subscriptions/power/upgrade`;
    return axiosInstance.get(url);
};

export const postMonthlyToAnnualUpgrade = (axiosInstance, data) => {
    const url = `v1/subscriptions/power/upgrade`;
    return axiosInstance.put(url, data);
};

export const confirmMonthlyToAnnualUpgrade = (axiosInstance, subscriptionId) => {
    const url = `v1/subscriptions/power/confirmpayment?sourceSubscriptionId=${subscriptionId}`;
    return axiosInstance.put(url);
};

export const deleteFailedMonthlyToAnnualUpgrade = (axiosInstance, subscriptionId) => {
    const url = `v1/subscriptions/power/failpayment?sourceSubscriptionId=${subscriptionId}`;
    return axiosInstance.delete(url);
};

export const simulatePastDue = (axiosInstance, data) => {
    const url = `v1/subscriptions/simulate-past-due`;
    return axiosInstance.post(url, data);
};
